import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	 userInfo:{}
  },
  getters: {
	  
  },
  mutations: {
	  changeUserInfo(state,userInfo){
		  state.userInfo = userInfo
	  },
	  changeQuotes(state){
	  		  state.quotes_status = !state.quotes_status
	  }
  },
  actions: {
  },
  modules: {
  }
})
